import {createHelpers} from 'vuex-map-fields';
import Echo from "laravel-echo";
import {goPageByUrl} from "../../helpers/urlFunctions";
import {getStateMenu} from "../../helpers/menuState";
import {includeCurrentUrlString} from "../../helpers/includeCurrentUrlString";
import {errorOutput} from "../../helpers/errorOutput";
import {__t} from "../../helpers/translate";
import getObjectPathProperty from '../../helpers/getObjectPathProperty'

const {getUserField, updateUserField} = createHelpers({
    getterType: 'getUserField',
    mutationType: 'updateUserField',
});


const state = {
    isLoadUser: false,
    user: {
        id: 0,
        user_id: 0,
        username: '',
        client: {
            "id": 0,
            "client_id": 0,
        },
        client_id: 0,
        token: '',
        token_api: '',
        token_api_client: '',
        locale: 'ua',
        currency: 'UAH',
        currency_suffix: '',
        api: '',
        pos_api: '',
        aggregator_api: '',
        cookieSettings: [],
    },
    menuMainItems: [],
    activeItemMenuMain: null,
    userSettings: [],
    isLoadPage: false,
    isLoadMenu: false,
    isOpenMenu: false,
    isLoadHeading: false,
    listCookieSettingsName: [
        'is_loop_audio',
    ]
}

const actions = {
    STATE_LOAD_PAGE({commit}, loadState) {
        commit('stateLoadPage', loadState);
    },
    STATE_LOAD_MENU({commit}, loadState) {
        commit('stateLoadMenu', loadState);
    },
    STATE_LOAD_HEADING({commit}, loadState) {
        commit('stateLoadHeading', loadState);
    },

    LOAD_USER({commit}, params) {
        state.isLoadUser = true;
        // $store.dispatch('user/LOGOUT_USER');
        $api.get('/internal/auth_user').then(({data}) => {
            if (data.status === "operation_success") {
                commit('pushUser', data.data);
            }
        }).catch(err => {
            if (err.response.data) {
                errorOutput(__t('O.ERROR_AUTH'), err.response.data, params.actionName);
            }
            $store.dispatch('user/LOGOUT_USER');
            state.isLoadUser = false;
        });
    },

    GET_MENU_MAIN({commit}) {
        $store.dispatch('user/STATE_LOAD_MENU', true);
        $api.get('/internal/get_menu_main')
            .then(resp => {
                if (resp.data) {
                    commit('getMenuMainApi', resp.data, 'getMenuMain');
                }
            })
            .catch(err => {
                errorOutput(__t('O.ERROR_GETTING_MENU'), err.message, 'getMenuMain');
            })
    },
    CLICK_ITEM_MENU_MAIN({commit}, itemMenu) {
        commit('clickItemMenuMain', itemMenu);
    },
    UPDATE_MENU_MAIN_INFO({commit}, params) {
        commit('updateMenuMainInfo', params);
    },
    CHANGE_USER_SETTING({commit}, params) {
        $api.patch('/internal/client/setting', params.bodyRequest)
            .then(resp => {
                if (resp.data) {
                    params.resp = resp.data;
                    commit('changeUserSetting', params);
                }
            })
            .catch(err => {
                errorOutput(__t('O.ERROR_CHANGE_USER_SETTING'), err);
            })
    },
    CHANGE_USER_SETTING_COOKIE({commit}, params) {
        $api.patch('/internal/client/setting_cookie', params.bodyRequest)
            .then(resp => {
                if (resp.data) {
                    params.resp = resp.data;
                    commit('changeUserSettingCookie', params);
                }
            })
            .catch(err => {
                errorOutput(__t('O.ERROR_CHANGE_USER_SETTING'), err);
            })
    },
    LOGOUT_USER({commit}) {
        $api.get('/internal/logout', {
            headers: {
                'Authorization': 'Bearer ' + state.user.token
            }
        })
            .then(resp => {
                goPageByUrl('/login');
            })
            .catch(err => {
                console.log('link error', err)
                goPageByUrl('/login');
            })
    },
}

const mutations = {
    updateUserField,
    pushUser(state, user) {
        state.user = {...state.user, ...user};
        if (user.client && user.client.data && user.client.data.client
            && user.client.data.client.currency && user.client.data.client.currency.suffix) {
            state.user.currency_suffix = user.client.data.client.currency.suffix;
        }
        if (parseInt(user.client.client_id) > 0) {
            EventBus.$emit('user_added', user);
            //Init Echo
            window.Echo = new Echo({
                broadcaster: "socket.io",
                host: 'https://api.getorder.biz',
                csrfToken: '',
                debug: true,
                bearerToken: user.client.token_api_client,
                auth: {
                    headers: {
                        Accept: 'application/json',
                    }
                }
            });


            try {
                window.Echo.private("customer." + user.client.client_id)
                    .listen('.order.add', (e) => {
                        if (localStorage.getItem('is_debug')) {
                            console.log('order.add', e);
                        }
                        executeOperation(e, 'order.add');
                    })
                    .listen('.order.state', (e) => {
                        if (localStorage.getItem('is_debug')) {
                            console.log('order.state', e);
                        }
                        executeOperation(e, 'order.state');
                    })
                    .listen('.order.delivery_state', (e) => {
                        if (localStorage.getItem('is_debug')) {
                            console.log('order.delivery_state', e);
                        }
                        executeOperation(e, 'order.delivery_state');
                    });
            } catch (e) {
                errorOutput(__t('O.ERROR_WORK_WITH_WEB_SOCKET'), e);
            }
        }
        state.isLoadUser = true;
        mutations.getUserSettings(state, {user: state.user});
        $store.dispatch('user/GET_MENU_MAIN');
    },


    getMenuMainApi(state, resp) {
        if (resp.data && resp.status === 'operation_success') {
            state.menuMainItems = resp.data;
        } else {
            errorOutput(__t('O.ERROR_GETTING_MENU'), 'Do not get menu main');
        }
        state.menuMainItems.forEach(item => {
            if (includeCurrentUrlString(item.url)) {
                item.isSelect = true;
            } else {
                item.isSelect = false;
            }
        })
        state.activeItemMenuMain = state.menuMainItems.find(item => item.isSelect);
        $store.dispatch('user/STATE_LOAD_MENU', false);
        $store.dispatch('aggregators/UPDATE_MENU_SELECT_LOCATIONS_COUNT', {actionName: 'updateMenuSelectLocationsCount'});
        $store.dispatch('orders/POS_RESTAURANTS_LIST', {actionName: 'posRestaurantsList'});
        EventBus.$emit('active_menu', getStateMenu());
        EventBus.$emit('load_menu_main');

    },
    clickItemMenuMain(state, itemMenu) {
        state.activeItemMenuMain = itemMenu;
        state.menuMainItems.forEach(item => item.isSelect = item === itemMenu);
        //setStateMenu(false, state.activeItemMenuMain.id, state.menuMainItems);
        goPageByUrl(state.activeItemMenuMain.url);
    },
    updateMenuMainInfo(state, params) {
        if (params !== null && typeof params === 'object') {
            state.menuMainItems.forEach(item => {
                for (let prop in params) {
                    if (item.name === prop) {
                        item.count = params[prop];
                    }
                }
            })
        }
    },
    getUserSettings(state, params) {
        if (params.user && params.user.client
            && params.user.client.data && params.user.client.data.client) {
            if (params.user.client.data.client.is_stop_on !== null) {
                let itemSetting = state.userSettings.find(item => item.parameter === 'is_stop_on');
                if (itemSetting === undefined) {
                    state.userSettings.push({
                        name: 'O.SYNC_STOP_LIST',
                        parameter: 'is_stop_on',
                        state: params.user.client.data.client.is_stop_on
                    });
                } else {
                    itemSetting.state = params.user.client.data.client.is_stop_on;
                }
            }
            if (params.user.client.data.client.is_auto_send !== null) {
                let itemSetting = state.userSettings.find(item => item.parameter === 'is_auto_send');
                if (itemSetting === undefined) {
                    state.userSettings.push({
                        name: 'O.AUTO_ACCEPTANCE_ORDERS',
                        parameter: 'is_auto_send',
                        state: params.user.client.data.client.is_auto_send
                    });
                } else {
                    itemSetting.state = params.user.client.data.client.is_auto_send;
                }
            }
            if (params.user.client.data.client.is_work_pos_state !== null) {
                let itemSetting = state.userSettings.find(item => item.parameter === 'is_work_pos_state');
                if (itemSetting === undefined) {
                    state.userSettings.push({
                        name: 'O.SYNC_STATE_WITH_POS',
                        parameter: 'is_work_pos_state',
                        state: params.user.client.data.client.is_work_pos_state
                    });
                } else {
                    itemSetting.state = params.user.client.data.client.is_work_pos_state;
                }
            }
        }
        if(params.user && params.user.cookieSettings && Array.isArray(params.user.cookieSettings)) {
            params.user.cookieSettings.forEach(item =>{
                if(state.listCookieSettingsName.includes(item.parameter)){
                    state.userSettings.push({
                        name: item.name,
                        parameter: item.parameter,
                        state: item.state,
                    });
                }
            })
        }
        EventBus.$emit('get_user_settings');
    },
    changeUserSetting(state, params) {
        if (params.resp.data && params.resp.status === 'operation_success') {
            EventBus.$emit('change_user_setting', params);
            return;
        }
        EventBus.$emit('change_user_setting', null);
    },
    changeUserSettingCookie(state, params) {
        if (params.resp.data && params.resp.status === 'operation_success') {
            const settingsCookie = params.resp.data;
            let itemFind = undefined;
            state.userSettings.forEach(setting => {
                itemFind = settingsCookie.find(itemCookie => {
                    return itemCookie.parameter === setting.parameter;
                })
                if(itemFind !== undefined && itemFind.state){
                    setting.state = itemFind.state;
                }
            })
        }
    },
    stateLoadPage(state, loadState) {
        state.isLoadPage = loadState;
    },
    stateLoadMenu(state, loadState) {
        state.isLoadMenu = loadState;
    },
    stateLoadHeading(state, loadState) {
        state.isLoadHeading = loadState;
    },
}
const getters = {
    getUserField,
    getUser(state) {
        return state.user;
    },
    getMenuMainItems(state) {
        return state.menuMainItems;
    },
    getUserSettings(state) {
        return state.userSettings;
    },
    getIsLoadPage(state) {
        return state.isLoadPage;
    },
    getIsLoadMenu(state) {
        return state.isLoadMenu;
    },
    getIsLoadHeading(state) {
        return state.isLoadHeading;
    },
}

function noFoundSelectLocationInOrder(event, operationName, selectLocationsId) {
    let locationId = null;
    if(operationName === 'order.add') {
        if(getObjectPathProperty(event, 'location.id')){
            locationId = event.location.id;
        }
    } else if(operationName === 'order.state' || operationName === 'order.delivery_state') {
        if(getObjectPathProperty(event, 'order.location.id')){
            locationId = event.order.location.id;
        }
    }
    if (locationId) {
        if (selectLocationsId.some(item => item === locationId)) {
            return false;
        }
    }
    return true;
}


function executeOperation(e, operationName) {
    let url = '/internal/aggregators/locations/id/select';
    if(e.is_delivery_provider || operationName === 'order.delivery_state') {
        url = '/internal/delivery/locations/id/select';
    }

    $api.get(url)
        .then(resp => {
            let selectLocationsId = [];
            if (resp.data && resp.data.data) {
                selectLocationsId = resp.data.data;
            }
            return selectLocationsId;
        })
        .then((selectLocationsId) => {
            if (noFoundSelectLocationInOrder(e, operationName, selectLocationsId)) {
                return;
            }
            if (operationName === 'order.add') {
                executePooling(e);
            } else if (operationName === 'order.state') {
                EventBus.$emit('change_state_order_event', e);
            } else if (operationName === 'order.delivery_state') {
                $store.dispatch('couriers/ORDERS_POOLING_DELIVERY', {
                    actionName: 'ordersPoolingDelivery'
                });
            }
        })
        .catch(error => {
            console.log(error);
            errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), error, operationName);
            if (operationName === 'order.add') {
                executePooling(e);
            } else if (operationName === 'order.state') {
                EventBus.$emit('change_state_order_event', e);
            } else if (operationName === 'order.delivery_state') {
                $store.dispatch('couriers/ORDERS_POOLING_DELIVERY', {
                    actionName: 'ordersPoolingDelivery'
                });
            }
        })
}

function executePooling(e) {
    if (e.is_delivery_provider) {
        $store.dispatch('couriers/ORDERS_POOLING_DELIVERY', {
            actionName: 'ordersPoolingDelivery'
        });
    } else {
        const params = {
            user: state.user,
            setDefaultOrder: false,
            eventSend: false,
            idOrder: e.id,
            newOrderIn: e,
        }
        $store.dispatch('orders/GET_ORDERS_POOLING', params);
    }
}

function executePoolingDelivery(e) {
    if (e.is_delivery_provider) {
        $store.dispatch('couriers/ORDERS_POOLING_DELIVERY', {
            actionName: 'ordersPoolingDelivery'
        });
    } else {
        const params = {
            user: state.user,
            setDefaultOrder: false,
            eventSend: false,
            idOrder: e.id,
            newOrderIn: e,
        }
        console.log(params)
        $store.dispatch('orders/GET_ORDERS_POOLING', params);
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

